export const checksums = {
  "articles": "v3.5.0--BFvvM8FhRghVa1Fu6-SES3WZFgJ-SJXbG1-51DkV5_Y"
}
export const checksumsStructure = {
  "articles": "AcpoMLP-N5jYeBbeMpDC3aC0iuLLz6EVJ9GR9-YzoF8"
}

export const tables = {
  "articles": "_content_articles",
  "info": "_content_info"
}

export default {
  "articles": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "date": "string",
      "description": "string",
      "extension": "string",
      "hot": "boolean",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string",
      "tags": "json"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}